export default __webpack_public_path__ + "static/media/sticker-tr.094b5444.png";